import React from 'react';
import { Badge } from 'reactstrap';
import { getWorkTypeBadgeColor } from '../../../constants/utils';
import { useTranslation } from 'react-i18next';

/**
 * Shared component for work type display
 *
 * @param {string} workType - Work type (PREVENTIVE, REACTIVE, etc.)
 * @param {boolean} uppercase - Uppercase label (default: true)
 * @param {string} className - Additional CSS classes
 */
const WorkTypeBadge = ({
  workType,
  uppercase = true,
  className = '',
}) => {
  const { t } = useTranslation();
  const color = getWorkTypeBadgeColor(workType);
  const label = workType ? t(`business.components.badges.work_type.${workType.toLowerCase()}`, workType) : t('shared.unknown', 'Unknown');
  const displayLabel = uppercase ? label.toUpperCase() : label;

  return (
    <Badge color={color} pill className={className}>
      {displayLabel}
    </Badge>
  );
};

export default WorkTypeBadge;
